import * as React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Blog from "../components/blog"
import Seo from "../components/seo"

type DataProps = {
  site: {
    buildTime: string
  }
}

const Elearnpremium: React.FC<PageProps<DataProps>> = ({ data, path }) => (
  <Blog>
    <Seo title="Aplikasi E-learn premium lengkap Sekolah" />
    <h1><strong><a href="/elearnpremium/">E-learn Media</a></strong></h1>
    <div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/VioIwalm0HM" title="pembuatan aplikasi e-learn sekolah"></iframe>
</div>
    <p>
Solusi terlengkap dan penuh interaksi untuk kebutuhan proses belajar mengajar menggunakan aplikasi sekolah e-learn premium ini.
    </p>
    <p>Siswa apps : Home page, chat pesan dengan guru pengajar, informasi tugas dan ujian soal , hasil ujian baik yang sudah dikerjakan dan belum dikerjakan, menjawab soal pertanyaan ujian real time dengan durasi waktu yang diberikan oleh guru pengajar, submit jawaban untuk menyelesaikan tugas, dan konvert hasil nilai otomatis setiap ujian soal dan tugas yang dikerjakan.</p>
<p>Guru admin apps : home page, data kelas, data siswa , data ujian untuk memasukan soal ujian dilengkapi dengan pertanyaan dan pilihan jawaban untuk memudahkan siswa dalam menjawab soal pertanyaan ujian ulangan dan lain nya, hasil ujian konvert otomatis ketika siswa sudah melaksanakan dan menjawab hasil ujian nya, laporan ujian untuk cek laporan laporan ujian perkelas dan persiswa , pesan chat untuk menerima pesan dari siswa untuk kebutuhan interaksi dengan guru pengajar.</p>
<div className="embed-responsive embed-responsive-16by9 rounded">
<iframe width="560" height="315" src="https://www.youtube.com/embed/_vg23sv_JVQ" title="pembuatan aplikasi e-learn sekolah"></iframe>
</div>
<p>Semakin mudah dengan dukungan APK android dalam bekerja untuk mobilitas pada aktivitas belajar mengajar</p>
<p>daftar harga layanan per tahun : 
<br/>E-learn premium Apps
<br/>Free Domain .sch.id
<br/>Web Space 1.5GB
<br/>Include Host
<br/>axcora school cms website
<br/>website sekolah
<br/>APK Android Guru
<br/>APK Android Siswa
<br/>Rp.2.712.300</p>
<a href="https://wa.me/6285646104747?text=Axcoraapps%20saya%20mau%20order%20Webapp%0ANama/Usaha%20%3A%0AAlamat%20%3A%0APaketwebapp%20elearnpremimumstandard%3A%0APrice%20%3ARp.2.712.300/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0ABRI%20008601112564504%20Soni%20Andrias%0Atolong%20diproses%20pesanan%20saya" className="button col-12">Order Now</a>
<br/>    <Link to="/">Go back to the homepage</Link>
  </Blog>
)

export default Elearnpremium

export const query = graphql`
  {
    site {
      buildTime(formatString: "YYYY-MM-DD hh:mm a z")
    }
  }
`
